'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = template;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Input = require('../../Input');

var _Input2 = _interopRequireDefault(_Input);

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

var _DatePicker = require('../../DatePicker');

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _reactTransitionGroup = require('react-transition-group');

var _reactEventListener = require('react-event-listener');

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function template() {
    var palette = this.props.theme.palette,
        inputTheme = {
        paddingRight: palette.gutter * 4 + 'px',
        width: '100%'
    },
        classList = this.compileStyle(_index2.default),
        datePicker = void 0,
        inputProps = void 0;


    if (this.state.active) {
        datePicker = _react2.default.createElement(
            _reactTransitionGroup.CSSTransition,
            {
                classNames: classList.animation,
                timeout: 450,
                key: 'datepicker'
            },
            _react2.default.createElement(
                'div',
                {
                    className: classList.picker + ' ' + classList.animation,
                    style: this._getPosition()
                },
                _react2.default.createElement(_DatePicker2.default, {
                    minYear: this.props.minYear,
                    maxYear: this.props.maxYear,
                    minMonth: this.props.minMonth,
                    maxMonth: this.props.maxMonth,
                    yearChange: this.props.yearChange,
                    allowedWeekDays: this.props.allowedWeekDays,
                    deniedDates: this.props.deniedDates,
                    allowedDates: this.props.allowedDates,
                    firstDay: this.props.firstDay,
                    isPeriod: this.props.isPeriod,
                    cancelButton: this.props.cancelButton,
                    submitButton: this.props.submitButton,
                    value: this.input.value || '',
                    onSubmit: this._handleSubmit,
                    onCancel: this._handleCancel
                })
            )
        );
    }

    inputProps = Object.assign({}, this.props, {
        style: Object.assign({}, inputTheme, this.props.style),
        onFocus: this._handleFocus,
        elementRef: this._inputRef,
        // current theme for dateInput
        theme: null,
        className: ''
    });

    return _react2.default.createElement(
        'div',
        {
            className: classList.root + ' ' + (this.props.className || ''),
            ref: this._rootRef
        },
        _react2.default.createElement(
            'div',
            {
                className: classList.wrapper,
                onMouseEnter: this._handleHover,
                onMouseLeave: this._handleRootBlur
            },
            _react2.default.createElement(_reactEventListener2.default, {
                target: window.document.querySelector('body'),
                onClick: this._handleBodyClick
            }),
            _react2.default.createElement(_Input2.default, inputProps),
            _react2.default.createElement('div', {
                className: classList.calendar,
                onClick: this._handleCalendarClick
            }),
            _react2.default.createElement(
                _reactTransitionGroup.TransitionGroup,
                null,
                datePicker
            )
        )
    );
}